import { render, staticRenderFns } from "./collapsed-menu.vue?vue&type=template&id=7a093560&"
import script from "./collapsed-menu.vue?vue&type=script&lang=js&"
export * from "./collapsed-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "collapsed-menu.vue"
export default component.exports